var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/defineProperty", "core-js/modules/web.dom.iterable", "core-js/modules/es6.array.iterator", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/helpers/objectWithoutProperties", "lodash.pick"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("core-js/modules/web.dom.iterable"), require("core-js/modules/es6.array.iterator"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/helpers/objectWithoutProperties"), require("lodash.pick"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.defineProperty, global.webDom, global.es6Array, global.es6Object, global.objectWithoutProperties, global.lodash);
    global.Utils = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _defineProperty3, _webDom, _es6Array, _es6Object, _objectWithoutProperties2, _lodash) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.breadcrumbify = _exports.getCredits = _exports.formatCredit = _exports.groupParentsByType = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _lodash = _interopRequireDefault(_lodash);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var groupParentsByType = function groupParentsByType(page) {
    var parents = {};
    var parent = page.parent;

    while (parent) {
      var _parent = parent,
          _ = _parent.parent,
          rest = (0, _objectWithoutProperties2.default)(_parent, ["parent"]);
      parents[parent.type] = rest;
      parent = parent.parent;
    }

    return parents;
  };

  _exports.groupParentsByType = groupParentsByType;

  var formatCredit = function formatCredit(credit) {
    return {
      label: credit.label,
      content: credit.values.length > 1 ? credit.values : credit.values[0]
    };
  };

  _exports.formatCredit = formatCredit;

  var getCredits = function getCredits(program) {
    var leftColumnCodes = ['IMA', 'MON', 'MUS', 'PRD', 'PRO', 'REA', 'SCE'];

    if (!program.credits) {
      return null;
    }

    var columns = program.credits.reduce(function (transformedCredits, credit) {
      var key = leftColumnCodes.indexOf(credit.code) === -1 ? 'columnRight' : 'columnLeft';
      transformedCredits[key].push(formatCredit(credit));
      return transformedCredits;
    }, {
      columnLeft: [],
      columnRight: []
    });
    return columns.columnLeft.length > 0 ? columns : {
      columnLeft: columns.columnRight,
      columnRight: []
    };
  };

  _exports.getCredits = getCredits;

  var breadcrumbify = function breadcrumbify(page) {
    var includePage = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!page) {
      return [];
    }

    var _groupParentsByType = groupParentsByType(page),
        category = _groupParentsByType.category,
        subcategory = _groupParentsByType.subcategory;

    var color = category && category.page;
    var breadcrumb = [category && (0, _lodash.default)(category, ['label', 'url']), subcategory && (0, _lodash.default)(subcategory, ['label', 'url']), includePage && {
      label: page.title,
      url: page.url
    }].filter(function (x) {
      return x;
    });
    return breadcrumb.map(function (item, index) {
      return color && index < breadcrumb.length - 1 ? _objectSpread(_objectSpread({}, item), {}, {
        color: color
      }) : item;
    });
  };

  _exports.breadcrumbify = breadcrumbify;
});